import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { observeDomTranslations } from '../i18nDomTranslations';
import styles from './GlobalLanguageToggle.module.css';

export default function GlobalLanguageToggle({ visible }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const stopObserving = observeDomTranslations(i18n.language);
    return stopObserving;
  }, [i18n.language]);

  if (!visible) return null;

  const nextLanguage = i18n.language === 'en' ? 'it' : 'en';

  return (
    <button
      type="button"
      onClick={() => i18n.changeLanguage(nextLanguage)}
      className={styles.languageButton}
      aria-label={i18n.t('Change Language')}
    >
      {i18n.language.toUpperCase()} / {nextLanguage.toUpperCase()}
    </button>
  );
}
